import { ReleaseRef } from 'hooks/data/versions/types';

import { DatasetRef } from './types';

export const datasetRefKey = ({ id, version, systemModel }: DatasetRef): string => `${version}|${systemModel}|${id}`;

export const isSameDatasetRef = (a: DatasetRef, b: DatasetRef): boolean => datasetRefKey(a) === datasetRefKey(b);

export const isSameRelease = (a: DatasetRef, b: DatasetRef): boolean =>
  a.version === b.version && a.systemModel === b.systemModel;

export const isSameSystemModel = (a: DatasetRef, b: DatasetRef): boolean => a.systemModel === b.systemModel;

export const toReleaseRef = ({ version, systemModel }: DatasetRef): ReleaseRef => ({
  version,
  system_model: systemModel,
});
